var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100px","overflow-y":"scroll"},style:({width:_vm.width})},[(_vm.list.length===0)?_c('div',[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('div',[_vm._v(_vm._s(item.ancestor_name))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3756911f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/EnergyConsumption/components/meter/components/SelectProjectTreeComponent.vue
// module id = null
// module chunks = 